import { render, staticRenderFns } from "./SlidePaymentList.vue?vue&type=template&id=5c01620e"
import script from "./SlidePaymentList.vue?vue&type=script&lang=js"
export * from "./SlidePaymentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports